import { Stack, HStack, Box, Flex, defineStyle } from '@chakra-ui/react';
import { Avatar, tools } from '@halo/ui-chat-react';
import { type GroupInfo } from '@halo/chat-sdk-react';
import QrCodeButton from '@/components/QrCodeButton';
import { ExpandableText } from '@/components/ExpandableText';
import { PreviewImageAvatar } from '@/components/ProfileDialog/Profile/Header';
import TextWithCopy from './TextWithCopy';

interface HeaderProps {
  group?: GroupInfo | null;
}

const Header = ({ group }: HeaderProps) => {
  const { t } = useTranslation();
  // const isDeleteGroup = useMemo(() => {
  //   return group?.state === StateEnum.DELETE_ACCOUNT;
  // }, [group?.state]);
  const isDeleteGroup = false;

  return (
    <>
      <Stack
        className="StackHeader"
        gap="0"
        bg="bg.subtle"
        w="full"
        pb="2.5"
        roundedTopLeft="2xl"
        roundedTopRight="2xl"
        mt="-2.5"
      >
        <Box bg={isDeleteGroup ? '#c5c5c5' : 'transparent'}>
          <HStack
            className="HStack"
            gap="2.5"
            bg="bg"
            pl="4"
            roundedTopLeft="2xl"
            roundedTopRight="2xl"
          >
            <Flex alignItems="center" gap="2.5" marginTop="-14px">
              <PreviewImageAvatar src={group?.avatar}>
                <Avatar
                  css={defineStyle({
                    outlineWidth: '3px',
                    outlineColor: 'bg',
                    outlineStyle: 'solid',
                  })}
                  src={group?.avatar}
                  name={group?.group_name}
                  w={86}
                  height={86}
                  activeShake={false}
                />
              </PreviewImageAvatar>

              {isDeleteGroup && (
                <Box truncate lineHeight="shorter" fontWeight="semibold" fontSize="xl">
                  {group?.group_name}
                </Box>
              )}
            </Flex>
            {!isDeleteGroup && (
              <Box flex="1 1 auto" overflow="hidden">
                <Flex
                  flex="1"
                  fontSize="xl"
                  gap="1"
                  mb="0.5"
                  pr="4"
                  alignItems="center"
                  justifyContent="space-between"
                >
                  <TextWithCopy text={group?.group_name}>
                    <Box
                      truncate
                      lineHeight="shorter"
                      fontWeight="semibold"
                      onClick={() => tools.copyToClipboard(group?.group_name)}
                      cursor="pointer"
                      fontSize="xl"
                    >
                      {group?.group_name}
                    </Box>
                  </TextWithCopy>
                  <HStack gap="2.5">
                    {group && (
                      <QrCodeButton
                        user={{
                          group_id: group.gid,
                          avatar: group.avatar,
                          name: group.group_name,
                          username: group.group_id,
                        }}
                        source="group"
                      />
                    )}
                  </HStack>
                </Flex>
                <Flex flex="1">
                  <TextWithCopy text={`@${group?.group_id}`}>
                    <Box
                      minW="50px"
                      truncate
                      onClick={() => tools.copyToClipboard(`@${group?.group_id}`)}
                      cursor="pointer"
                      fontSize="sm"
                    >
                      @{group?.group_id}
                    </Box>
                  </TextWithCopy>
                </Flex>
              </Box>
            )}
          </HStack>
        </Box>
        <Box
          py="2.5"
          px="5"
          bg="linear-gradient(to bottom, var(--colors-bg), var(--colors-bg-subtle))"
        >
          {!isDeleteGroup && (
            <ExpandableText text={group?.description || ''}>
              {t('profile.groupNoBio')}
            </ExpandableText>
          )}
        </Box>
      </Stack>
    </>
  );
};

const MemoizedHeader = memo(Header);
export { MemoizedHeader as Header };
